import { EditChildEnrollmentModalComponent } from './edit-child-enrollment-modal/edit-child-enrollment-modal.component';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { Region } from 'src/app/model/region.model';
import { HelperService } from 'src/app/service/helper.service';
import { SchoolEnrollment } from './../../model/school-enrollment.model';
import { StudentSchoolEnrollmentService } from './../../service/student-school-enrollment.service';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { StudentHelperService } from '../../service/student-helper.service';
import { Student } from 'src/app/model/student/student.model';
import { Subscription } from 'rxjs';
import { StudentEligibilitiesService } from '../../service/student-eligibilities.service';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { Router } from '@angular/router';

@Component({
    selector: 'edit-child-enrollment',
    templateUrl: './edit-child-enrollment.component.html',
    styleUrls: ['./edit-child-enrollment.component.scss']
})
export class EditChildEnrollmentComponent implements OnInit {
    @Input() studentId!: number;
    @Input() editing: boolean;
    @Output() editingChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    student: Student;
    schoolEnrollments: SchoolEnrollment[] = [];
    provisionalSchoolEnrollments: SchoolEnrollment[] = [];
    userRegion: Region;
    userSchoolDistricts: any;
    missingCOE: boolean;

    featuresCheck: string[] = ['Create Student School Enrollments', 'Edit Student School Enrollments', 'Delete Student School Enrollments'];
    featurePermissions: any = {};
    hasAdminRole: boolean = false;

    isLoading: boolean = false;
    promises: Array<any> = [];

    getPropertyPipe = new GetPropertyPipe();
    cleanDatePipe = new CleanDatePipe();
    simpleDatePipe = new SimpleDatePipe();

    // Table display
    schoolEnrollmentDisplayedColumns: string[] = [
        'EDIT',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.TRACK',
        'COUNTy.COUNTY_CODE',
        'SCHOOL_DISTRICT.DISTRICTS',
        'SCHOOL.NAME',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.DEPARTURE_DATE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.PFS',
        'SOURCE'
    ];
    provisionalSchoolEnrollmentDisplayedColumns: string[] = [
        'SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.TRACK',
        'PARTY_RELATIONSHIPS.PARTY_ROLES.PARTy.PROVISIONAL_SCHOOLS[0].DISTRICT',
        'PARTY_RELATIONSHIPS.PARTY_ROLES.PARTy.PROVISIONAL_SCHOOLS[0].SCHOOL_NAME',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.DEPARTURE_DATE',
        'SCHOOL_ENROLLMENT_DETAILS_ASL.PFS'
    ];

    // Table results
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    regions: any[] = [];
    provisionalSchoolEnrollmentTableDataSource: MatTableDataSource<SchoolEnrollment>;

    subs: Subscription[] = [];

    constructor(
        private studentSchoolEnrollmentService: StudentSchoolEnrollmentService,
        private helperService: HelperService,
        private dialog: MatDialog,
        private studentHelper: StudentHelperService,
        private studentEligibilitiesService: StudentEligibilitiesService,
        private accessService: AccessService,
        private loginTokenService: LoginTokenService,
        private router: Router
    ) {
        this.subscriptions();
    }

    subscriptions() {
        let studentSub = this.studentHelper.student$.subscribe((student) => {
            this.student = student;
        });

        this.subs.push(studentSub);
    }

    ngOnInit(): void {}

    init() {
        this.isLoading = true;

        this.getSchoolEnrollments();
        this.getProvisionalSchoolEnrollments();
        this.getUserRegion();
        this.getUserSchoolDistricts();
        this.getFeaturePermissions();
        this.getAdministrator();
        Promise.all(this.promises).then((res) => {
            this.getLatestCoeAndEligiblity([this.student]);
            this.updateDataSource();

            this.isLoading = false;
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.editing) {
            this.schoolEnrollmentDisplayedColumns = [
                'EDIT',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.TRACK',
                'COUNTy.COUNTY_CODE',
                'SCHOOL_DISTRICT.DISTRICTS',
                'SCHOOL.NAME',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.DEPARTURE_DATE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.PFS',
                'SOURCE'
            ];
        } else {
            this.schoolEnrollmentDisplayedColumns = [
                'EDIT',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.TRACK',
                'COUNTy.COUNTY_CODE',
                'SCHOOL_DISTRICT.DISTRICTS',
                'SCHOOL.NAME',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.DEPARTURE_DATE',
                'SCHOOL_ENROLLMENT_DETAILS_ASL.PFS',
                'SOURCE'
            ];
            if (changes['editing']) {
                this.init();
            }
        }
    }

    getUserRegion() {
        let deferred = new Promise((resolve, reject) => {
            this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
                this.userRegion = userRegion[0];

                resolve(this.userRegion);
            });
        });

        this.promises.push(deferred);
    }

    getUserSchoolDistricts() {
        let deferred = new Promise((resolve, reject) => {
            this.accessService.getSchoolDistrictAccess().subscribe((schoolDistricts) => {
                if (schoolDistricts) {
                    this.userSchoolDistricts = schoolDistricts;
                }
                resolve(schoolDistricts);
            });
        });

        this.promises.push(deferred);
    }

    getSchoolEnrollments() {
        let deferred = new Promise((resolve, reject) => {
            this.studentSchoolEnrollmentService.getSchoolEnrollments(this.studentId).subscribe((res) => {
                if (res.schoolEnrollments) {
                    this.schoolEnrollments = res.schoolEnrollments;

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getProvisionalSchoolEnrollments() {
        let deferred = new Promise((resolve, reject) => {
            this.studentSchoolEnrollmentService.getProvisionalSchoolEnrollments(this.studentId).subscribe((res) => {
                if (res.provisionalSchoolEnrollments) {
                    this.provisionalSchoolEnrollments = res.provisionalSchoolEnrollments;

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getLatestCoeAndEligiblity(students: any[]) {
        let deferred = new Promise((resolve, reject) => {
            let studentIDs: any[] = students.map((student) => {
                return { ID: student.ID };
            });
            this.studentEligibilitiesService.getLatestCoeAndEligiblity(studentIDs).subscribe((res) => {
                if (res.students) {
                    let find = '-';
                    let re = new RegExp(find, 'g');
                    let student = res.students[0];

                    this.student = Object.assign({}, this.student, (({ SCHOOL_ENROLLMENT_DETAILS }) => ({ SCHOOL_ENROLLMENT_DETAILS }))(student));
                    this.studentHelper.setStudent(this.student);

                    student.SCHOOL_ENROLLMENT_DETAILS.find((sed: any) => {
                        if (
                            !re.test(this.getPropertyPipe.transform(sed, 'STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')) &&
                            this.getPropertyPipe.transform(this.userRegion, 'ID') === this.getPropertyPipe.transform(sed, 'COES[0].REGION.ID')
                        ) {
                            this.missingCOE = false;
                            return true;
                        } else {
                            this.missingCOE = true;
                            return false;
                        }
                    });

                    resolve(res);
                } else if (res?.msg) {
                    this.missingCOE = true;
                    resolve(res);
                } else {
                    this.missingCOE = true;
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getFeaturePermissions() {
        let deferred = new Promise((resolve, reject) => {
            this.accessService.getFeatureAccessPromise(this.featuresCheck).then((res) => {
                this.featurePermissions = res;
                resolve(res);
            });
        });
        this.promises.push(deferred);
    }

    getAdministrator() {
        let deferred = new Promise((resolve, reject) => {
            let user = this.loginTokenService.getUser();
            let adminUserIds = [1, 9]; // System Administrator (1), State Administrator (9)
            this.hasAdminRole = user.USER_ROLES?.some((ur) => adminUserIds.includes(ur.ROLE?.ID ? ur.ROLE.ID : 0))!;
            resolve(this.hasAdminRole);
        });
        this.promises.push(deferred);
    }

    updateDataSource() {
        setTimeout(() => {
            this.regions = this.getRegions(this.schoolEnrollments);

            setTimeout(() => {
                this.regions.forEach((region, index) => {
                    let dataSource = new MatTableDataSource<SchoolEnrollment>();
                    dataSource.data = region.SCHOOL_ENROLLMENTS.sort((a: any, b: any) =>
                        a.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE! > b.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE! ? -1 : 1
                    );

                    dataSource.sort = this.sorts.toArray()[index];
                    const defaultSort: Sort = { active: 'SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR', direction: 'desc' };
                    dataSource.sort.active = defaultSort.active;
                    dataSource.sort.direction = defaultSort.direction;
                    dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

                    region.tableDataSource = dataSource;

                    setTimeout(() => {
                        region.tableDataSource.sort?.sortChange.emit(defaultSort);
                    });
                });
            });
        });

        if (this.provisionalSchoolEnrollments.length > 0) {
            setTimeout(() => {
                // Data
                let dataSource = new MatTableDataSource<SchoolEnrollment>();
                dataSource.data = this.provisionalSchoolEnrollments;

                dataSource.sort = this.sorts.toArray()[this.regions.length];
                const defaultSort: Sort = { active: 'SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR', direction: 'desc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

                this.provisionalSchoolEnrollmentTableDataSource = dataSource;

                this.provisionalSchoolEnrollmentTableDataSource.sort?.sortChange.emit(defaultSort);
            });
        }
    }

    getRegions(schoolEnrollments: SchoolEnrollment[]) {
        let regions: any[] = [];

        schoolEnrollments.forEach((se) => {
            let regionIndex = regions.findIndex((r) => r.CODE === se.REGION.CODE);

            if (regionIndex === -1) {
                let region: any = se.REGION;
                region.SCHOOL_ENROLLMENTS = [];
                region.SCHOOL_ENROLLMENTS.push(se);

                regions.push(region);
            } else {
                regions[regionIndex].SCHOOL_ENROLLMENTS.push(se);
            }
        });

        // Set user's region to top
        if (this.userRegion) {
            regions = regions.sort((a, b) => (a.CODE! > b.CODE! ? 1 : -1));
            let userRegionIndex = regions.findIndex((r) => r.CODE === this.userRegion.CODE);

            if (userRegionIndex >= 0) {
                regions.splice(0, 0, regions.splice(userRegionIndex, 1)[0]);
            }
        } else {
            regions = regions.sort((a, b) => (a.CODE! > b.CODE! ? 1 : -1));
        }

        return regions;
    }

    getCreatedOn(createdDate: any) {
        return 'Created on ' + this.simpleDatePipe.transform(this.cleanDatePipe.transform(createdDate));
    }

    editDialog(schoolEnrollment?: SchoolEnrollment) {
        let payload: any = {};
        payload.students = [{ ID: this.studentId }];
        if (schoolEnrollment) {
            payload.schoolEnrollment = schoolEnrollment;
        }

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(EditChildEnrollmentModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
                if (res.refresh) {
                    this.init();
                }
            }
        });
    }

    viewDialog(schoolEnrollment?: SchoolEnrollment) {
        let payload: any = {};
        payload.students = [{ ID: this.studentId }];
        if (schoolEnrollment) {
            payload.schoolEnrollment = schoolEnrollment;
        }
        payload.mode = 'view';

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(EditChildEnrollmentModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
                console.log(res.msg);
            }
        });
    }

    deletedSchoolEnrollment(schoolEnrollments: SchoolEnrollment[]) {
        schoolEnrollments.forEach((schoolEnrollment) => {
            let findSchoolEnrollmentIndex = this.schoolEnrollments.findIndex((se: SchoolEnrollment) => se.ID === schoolEnrollment.ID);

            if (findSchoolEnrollmentIndex >= 0) {
                this.schoolEnrollments.splice(findSchoolEnrollmentIndex, 1);

                this.updateDataSource();
            }
        });
    }
}
